import React from 'react';
import './Thread.css';


const ThreadItem = (props) => {


  return (
    <div className="Person">
      {props.threadItem._source.eventFrom}<br></br>
      Sent: {new Date(props.threadItem._source.appTimestamp).toLocaleString()}<br></br>
      <div dangerouslySetInnerHTML={{__html: props.threadItem._source.bodyPreview}} />
    </div>
  );
}

export default ThreadItem;



// WEBPACK FOOTER //
// ./src/containers/Timeline/ThreadItem.js